import React from 'react';
import PropTypes from 'prop-types';

import EmployeeBasic from './Tabs/basic';

const EmployeeNew = ({
  employee,
  designations,
  locations,
  portfolios,
  productTypes,
  stages,
  onBasicInfoUpdate,
  onCancelClick,
  ability,
}) => {
  return (
    <EmployeeBasic
      employee={employee}
      designations={designations}
      locations={locations}
      portfolios={portfolios}
      productTypes={productTypes}
      stages={stages}
      onBasicInfoUpdate={onBasicInfoUpdate}
      isNew={true}
      onCancelClick={onCancelClick}
      ability={ability}
    />
  );
};

EmployeeNew.defaultProps = {};

EmployeeNew.propTypes = {
  employee: PropTypes.object,
  designations: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  portfolios: PropTypes.array.isRequired,
  onBasicInfoUpdate: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
};

export default EmployeeNew;
